module.exports = __webpack_public_path__ + "fonts/Flaticon2.29586ff0.eot";